module.exports = __webpack_public_path__ + "img/20.422f0d2.jpg";